import React from 'react';
import { Row } from 'antd';
import { useTranslation } from 'react-i18next';

import Dropdown from '../../../../common/Dropdown';
import { getAvailableLayoutFields } from '../../../helpers';
import viewSettingsActions from '../../../../../actions/viewSettingsActions';
import { VIEW_MODES, SETTINGS_KEYS } from '../../../../../configs/viewSettings';

import styles from '../config.less';

const Split = (props) => {
  const { t } = useTranslation();

  if (!props.settings) {
    return null;
  }

  const value = props.settings.getIn([SETTINGS_KEYS.SPLIT, SETTINGS_KEYS.FIELD_ID]);
  const items = getAvailableLayoutFields(props.fields);

  const handleChange = (selectedItem) => {
    const fieldId = selectedItem ? selectedItem.key : null;
    const option = fieldId ? { type: 'field', fieldId } : null;
    viewSettingsActions.setOption({
      catalogId: props.catalogId,
      viewId: props.viewId,
      viewMode: VIEW_MODES.CALENDAR,
      option: SETTINGS_KEYS.SPLIT,
      value: option,
    });
  };

  return items && props.view === 'day' ? (
    <Row className={styles.controlRow}>
      <label className={styles.controlLabel}>{t('calendar.config.layout')}</label>
      <Dropdown
        disabled={!items.length}
        items={[{ key: null, text: '' }, ...items]}
        value={value}
        autocomplete
        withButton
        multiselect={false}
        onSelectItems={([item]) => handleChange(item)}
      />
    </Row>
  ) : null;
};

export default Split;
